import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DialogRef } from '@pixelgenau/ngx-dialog';
import { fromEvent } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class BackButtonService {
    private destroyRef = inject(DestroyRef);

    handleBackButton(dialogRef: DialogRef<boolean>): void {
        history.pushState(null, '');

        fromEvent(window, 'popstate')
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
                dialogRef.close(true);
                history.replaceState(null, '');
            });
    }
}
